import { createSlice } from "@reduxjs/toolkit";
import { Voucher, SpecialRequest } from "@/types/*";
import storage from "../../constants/storage";
import { createTripObjectRefine } from "../../services/refineObject/refineObject";

export const bookingType = {
  NEW_BOOKING: "NEW_BOOKING",
  MANAGE_BOOKING: "MANAGE_BOOKING",
  CHECKIN_BOOKING: "CHECKIN_BOOKING",
  CHANGE_BOOKING: "CHANGE_BOOKING"
};
export const bookingIniatedFrom = {
  NEW_BOOKING: "NEW_BOOKING",
  MANAGE_BOOKING: "MANAGE_BOOKING",
  CHECKIN_BOOKING: "CHECKIN_BOOKING"
};

const progressStage = {
  notStarted: -1,
  bookingIniated: 0,
  passengerInfoAdded: 1
};

const tripType = {
  1: "ONE_WAY",
  2: "ROUND_TRIP"
};
const addhosInitValues = {
  excessBaggage: {},
  meals: {},
  priorityCheckin: {},
  boardingFirst: {}
};

const listVoucherCodesInital = [
  {
    id: 0,
    voucher: "",
    error: false,
    duplicateVoucherError: false,
    voucherHasNoBalanceError: false,
    voucherExpiredError: false,
    voucherClassServiceException: false,
    noBalanceDueForPAX: false,
    maxVoucherLimitExceeded: false,
    errorMessage: '',
    applied: false,
    isValid: false
  } as Voucher
];

const initialStateOfBooking = {
  bookingType: bookingType.NEW_BOOKING,
  bookingIniatedFrom: bookingIniatedFrom.NEW_BOOKING,
  progressStage: progressStage.notStarted,
  currentBookingInState: {},
  initBookingInState: {}, // this will help to see the diff of updated booking
  origin: "",
  destination: "",
  addhons: [],
  Totalprice: 0,
  priceBreakDown: {},
  onlyFlightPrice: 0,
  onlyAddhosPrice: 0,
  tripType: tripType[1],
  bookingCreatedObject: {},
  addhonsInCart: {},
  runningAddhons: {},
  runningBundleAddhons: {},
  addhosFare: {},
  priceDiff: 0,
  refundedAmount: "",
  cancelledAmount: "",
  refundInitiatedDate: "",
  paymentType:"",
  selectedJourneyForUndoCheckIn: {},
  showPriceBreakDown: true,
  autoCheckinResponse: {},
  affiliateId: "",
  affiliateImpressionId: "",
  affiliateData: {},
  trackRefundAmount: "",
  refundDate:"",
  refundRNN:"",
  refundStatus:"",
  refundPnr:"",
  redirectId: "",
  listVoucherCodes: listVoucherCodesInital,
  specialRequests: [],
  nationality: {},
  isNewSSRPurchaseInChangeBookingFlow: false,
  currentBookingInStateCancelBooking: {},
  deeplinkCurrencyChange: "",
  specialFarePassengers: [],
  currentBoardingPassInState: {},
  updateBookingInState: {},
  selectedJourneyKeys: []
};

export const bookingSlice = createSlice({
  name: "booking",
  initialState: initialStateOfBooking,
  reducers: {
    initiateBooking: (state) => {
      storage.removeItem("persist:root");
      state = initialStateOfBooking;
    },
    setRefundedAmount: (state, action) => {
      state.refundedAmount = action.payload;
    },
    setRefundInitiatedDate: (state,action)=>{
      state.refundInitiatedDate = action.payload;
    },
    setPaymentTransactType: (state,action)=>{
      state.paymentType = action.payload;
    },
    setCancelledAmount: (state, action) =>{
      state.cancelledAmount = action.payload;
    },
    setTrackedRefundAmount: (state,action)=>{
      state.trackRefundAmount = action.payload;
    },
    setRefundDate: (state,action)=>{
      state.refundDate = action.payload;
    },
    setRefundRRN: (state,action)=>{
      state.refundRNN = action.payload;  
    },
    setRefundStatus: (state,action)=>{
      state.refundStatus = action.payload;
    },
    setSelectedDeeplinkCurrencyChange: (state,action) =>{
      state.deeplinkCurrencyChange = action.payload
    },
    setSpecialFarePassengers: (state,action) =>{
      state.specialFarePassengers = action.payload
    },
    setPNR: (state,action)=>{
      state.refundPnr = action.payload;
    },
    resetBookingInfo: (state, action) => {
      const filterDataFromObject = createTripObjectRefine(action.payload?.createBookingResponse?.data);

      state.bookingType = bookingType.NEW_BOOKING;
      if (filterDataFromObject.status) {
        state.onlyFlightPrice = filterDataFromObject.data.onlyFlightCost;
        state.tripType = tripType[filterDataFromObject?.data?.journeys?.length];
      }
      state.addhonsInCart = addhosInitValues;
      state.runningAddhons = addhosInitValues;
      state.runningBundleAddhons = {};
      state.addhosFare = addhosInitValues;
      state.listVoucherCodes = listVoucherCodesInital;
      //   state.origin = action.origin;
      //   state.destination = action.destination;
    },
    bookingCreated: (state, action) => {
      const filterDataFromObject = createTripObjectRefine(action.payload?.createBookingResponse?.data);

      state.bookingType = bookingType.NEW_BOOKING;
      if (filterDataFromObject.status) {
        state.onlyFlightPrice = filterDataFromObject.data.onlyFlightCost;
        state.tripType = tripType[filterDataFromObject?.data?.journeys?.length];
      }
      state.addhonsInCart = addhosInitValues;
      state.runningAddhons = addhosInitValues;
      state.runningBundleAddhons = {};
      state.addhosFare = addhosInitValues;
      state.progressStage = progressStage.bookingIniated;
      state.listVoucherCodes = listVoucherCodesInital;
      //   state.origin = action.origin;
      //   state.destination = action.destination;
    },

    addingExcessBag: (state, action) => {
      const tempState = JSON.parse(JSON.stringify(state));

      if (tempState?.addhonsInCart && action?.payload?.selectedAddhos) {
        tempState.addhonsInCart.excessBaggage = action?.payload?.selectedAddhos;
      }
      state.addhonsInCart = tempState.addhonsInCart;
    },
    selectingExcessBag: (state, action) => {
      const tempState = JSON.parse(JSON.stringify(state));
      if (tempState?.runningAddhons && action?.payload?.selectingExcessBag) {
        tempState.runningAddhons.excessBaggage = action?.payload?.selectingExcessBag;
      }
      state.runningAddhons = tempState.runningAddhons;
    },
    resetExcessBaggage: (state) => {
      const tempState = JSON.parse(JSON.stringify(state));
      if (tempState?.addhonsInCart) {
        tempState.addhonsInCart.excessBaggage = {};
        tempState.runningAddhons.excessBaggage = {};
      }
      state.addhonsInCart = tempState.addhonsInCart;
      state.runningAddhons = tempState.runningAddhons;
    },
    addingSsr: (state, action) => {
      const tempState = JSON.parse(JSON.stringify(state));

      if (tempState?.runningAddhons && action?.payload?.selectedAddhos) {
        tempState.runningAddhons[action?.payload?.ssrCode] = action?.payload?.selectedAddhos;
      }
      state.runningAddhons = tempState.runningAddhons;
    },
    removingSsr: (state, action) => {
      const tempState = JSON.parse(JSON.stringify(state));

      if (tempState?.runningAddhons && tempState?.runningAddhons[action?.payload?.ssrCode]) {
        delete tempState.runningAddhons[action?.payload?.ssrCode];
      }
      if (tempState.addhosFare[action?.payload?.ssrCode]) {
        // reseting the fare also
        delete tempState.addhosFare[action?.payload?.ssrCode];
      }
      state.runningAddhons = tempState.runningAddhons;
      state.addhosFare = tempState.addhosFare;
    },
    addingSsrFare: (state, action) => {
      const tempState = JSON.parse(JSON.stringify(state));
      if (tempState && action?.payload?.fare) {
        if (!tempState.addhosFare) {
          tempState.addhosFare = {};
        }
        tempState.addhosFare[action?.payload?.ssrCode] = action?.payload?.fare;
      }
      state.addhosFare = tempState.addhosFare;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
    setBookingIniatedFrom: (state, action) => {
      state.bookingIniatedFrom = action.payload.bookingIniatedFrom;
    },
    changeBookingIniated: (state, action) => {
      state.bookingIniatedFrom = action.payload.bookingIniatedFrom;
      state.bookingType = action.payload.bookingType;
      state.addhonsInCart = addhosInitValues;
      state.runningAddhons = addhosInitValues;
    },
    resetAddhos: (state) => {
      state.addhonsInCart = addhosInitValues;
      state.runningAddhons = addhosInitValues;
      state.addhosFare = addhosInitValues;
      state.priceDiff = 0;
    },
    setRunningBundleAddhons: (state, action) => {
      state.runningBundleAddhons = action.payload.runningBundleAddhons;
    },
    setCurrentBookingInState: (state, action) => {
      state.currentBookingInState = action.payload.currentBookingInState;
    },
    setInitBookingInState: (state, action) => {
      state.initBookingInState = action.payload.currentBookingInState;
    },
    setBookingType: (state, action) => {
      state.bookingType = action.payload.bookingType;
    },
    setPriceDiff: (state, action) => {
      state.priceDiff += action.payload.amount;
    },
    resetPriceDiff: (state) => {
      state.priceDiff = 0;
    },
    setUndoCheckInJourney: (state, action) => {
      state.selectedJourneyForUndoCheckIn = action.payload.journey;
    },
    setShowPriceBreakDown: (state, action) => {
      state.showPriceBreakDown = action?.payload?.showPriceBreakDown ?? true;
    },
    autoCheckinApiResponse: (state, action) => {
      state.autoCheckinResponse = action.payload.data;
    },
    flightSearchForBooking: (state) => {
      state.progressStage = progressStage.notStarted;
    },
    setAffiliateId: (state, action) => {
      state.affiliateId = action.payload.affiliateId;
    },
    setAffiliateImpressionId: (state, action) => {
      state.affiliateImpressionId = action.payload.affiliateImpressionId;
    },
    setAffiliateInfo: (state, action) => {
      state.affiliateData = action.payload.affiliateData;
    },
    setAffiliateRedirectId: (state, action) => {
      state.redirectId = action.payload.redirectId;
    },
    resetAffiliateId: (state) => {
      state.affiliateId = "";
      state.affiliateImpressionId = "";
      state.affiliateData = {};
      state.redirectId = "";
    },
    setVoucherList: (state, action) => {
      state.listVoucherCodes = action.payload;
    },
    resetVoucherList: (state) => {
      state.listVoucherCodes = listVoucherCodesInital;
    },
    addSpecialRequests: (state, action) => {
      const currentSpecialRequest: SpecialRequest[] = state.specialRequests;
      currentSpecialRequest.push(action.payload);
      state.specialRequests = currentSpecialRequest;
    },
    removeSpecialRequest: (state, action) => {
      let currentSpecialRequest: SpecialRequest[] = state.specialRequests;
      currentSpecialRequest = currentSpecialRequest.filter((specialRequest)=>specialRequest.paxIndex !== action.payload);
      state.specialRequests = currentSpecialRequest;
    },
    resetSpecialRequests: (state) => {
      let currentSpecialRequest = [];
      state.specialRequests = currentSpecialRequest;
    },
    setNationality: (state,action) => {
      state.nationality = action.payload;
    },
    setIsNewSSRPurchaseInChangeBookingFlow: (state, action) => {
      state.isNewSSRPurchaseInChangeBookingFlow = action?.payload?.isNewSSRPurchaseInChangeBookingFlow;
    },
    resetIsNewSSRPurchaseInChangeBookingFlow: (state) => {
      state.isNewSSRPurchaseInChangeBookingFlow = false
    },
    setBoardingPassInState:  (state, action) => {
      state.currentBoardingPassInState = action.payload.currentBoardingPassInState;
    },
    setCurrentBookingInStateCancelBooking: (state, action) => {
      state.currentBookingInStateCancelBooking = action.payload.currentBookingInStateCancelBooking;
    },
    setSelectedJourneyKeys: (state, action) => {
      state.selectedJourneyKeys = action.payload;
    }
  }
});

export const {
  bookingCreated,
  decrement,
  incrementByAmount,
  addingExcessBag,
  resetExcessBaggage,
  initiateBooking,
  selectingExcessBag,
  setBookingIniatedFrom,
  changeBookingIniated,
  resetAddhos,
  addingSsr,
  addingSsrFare,
  removingSsr,
  setCurrentBookingInState,
  setRunningBundleAddhons,
  setInitBookingInState,
  setBookingType,
  setPriceDiff,
  resetPriceDiff,
  setUndoCheckInJourney,
  setShowPriceBreakDown,
  autoCheckinApiResponse,
  flightSearchForBooking,
  setAffiliateId,
  setAffiliateRedirectId,
  resetAffiliateId,
  setAffiliateInfo,
  setAffiliateImpressionId,
  setVoucherList,
  resetVoucherList,
  addSpecialRequests,
  removeSpecialRequest,
  setRefundedAmount,
  setCancelledAmount,
  setPaymentTransactType,
  setRefundInitiatedDate,
  resetSpecialRequests,
  setNationality,
  setTrackedRefundAmount,
  setRefundDate,
  setRefundRRN,
  setRefundStatus,
  setPNR,
  setIsNewSSRPurchaseInChangeBookingFlow,
  resetIsNewSSRPurchaseInChangeBookingFlow,
  setBoardingPassInState,
  setSpecialFarePassengers,
  setSelectedDeeplinkCurrencyChange,
  setCurrentBookingInStateCancelBooking,
  setSelectedJourneyKeys
} = bookingSlice.actions;

export default bookingSlice.reducer;
